<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState({
      isMobile: (state) => state.ui.isMobile,
      profile: (state) => state.profile?.profile,
      organization: (state) => state.organization.organization,
    }),
  },
  mounted() {
    this.detectScreen();
  },
  created() {
    window.addEventListener('resize', this.detectScreen);
    this.checkAuth();
  },
  destroyed() {
    window.removeEventListener('resize', this.detectScreen);
  },
  methods: {
    ...mapActions({
      checkAuth: 'auth/checkAuth',
      getProfileFromStorage: 'profile/getProfileFromStorage',
      setMobile: 'ui/setMobile',
    }),
    detectScreen() {
      const actualWidth = window.innerWidth;
      const actualState = actualWidth < this.$consts.MOBILE_BREAKPOINT;
      if (this.isMobile !== actualState) {
        this.setMobile(actualState);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#q-app {
  height: 100%;
  min-height: 100vh;
}
</style>
